module.exports = __webpack_public_path__ + "static/img/Servicio5.f38063fb.png";